import { getCurrentAccount } from '@/graphql/queries/banking/current-account';
import lang from '@/lang/middleware/products/banking/current-accounts';
import { feeNote } from '@/scripts/current';

export default async ({ $apolloQuery, app, redirect, route, store }) => {
  await $apolloQuery(getCurrentAccount, { code: route.params.code }).then(account => {
    if ((route.params.slug !== account.slug) || (route.params.provider !== account.institution.slug)) {
      return redirect(301, app.localePath(`/compare-current-accounts/${account.institution.slug}/${account.code}/${account.slug}/`));
    }

    store.$i18n.mergeLocaleMessage('en', lang.en);

    const list = [
      ['contactless_pay', 'mobile_money', 'onlineaccess'].find(f => account[f]),
      account.overdraft_approved_apr ? 'overdraft_approved_apr' : null,
      ['feefree', 'reduced_fees', 'cashback'].find(f => account[f])
    ].filter(f => f).map(f => store.$i18n.t(`show.jumbotron.features.${f}`));
    const tacs = feeNote(account, store.$i18n);
    const title = [account.institution.name, account.name].join(' ');
    store.commit('products/set', account);
    store.commit('jumbotron/SET_JUMBOTRON', { list, tacs, title, type: 'generic' });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'],
      ['i18n/banking', '/money/'],
      ['i18n/current-accounts', '/compare-current-accounts/'],
      ['i18n/providers', '/compare-current-accounts/providers/'],
      [account.institution.name, `/compare-current-accounts/${account.institution.slug}/`, 'mobile'],
      account.name
    ]);
    store.commit('pageContent/setHead', { title });
  });
};
